import React from 'react'
import { ButtonGroup } from 'react-bootstrap'
import { formatMoney, getWindow } from '@ztechapps/common.utils'
import { BusyButton } from '@ztechapps/webui.button'
import { useCheckoutContext } from '../../../index'

export const PrintGenerated = ({ bankInfo }) => {
  const context = useCheckoutContext()
  const onSuccess = async () => {
    await context.onSuccess?.()
  }

  const onPrint = async () => {
    //this will initiate the creation of source for the customer
    //if the customer exists attach the source to the customer
    //create first teh customer, then create teh source then attach it
    //after the operation set the print info button
    const win = getWindow()
    win.print()

    //call the check-out on success function
    await onSuccess?.()
  }

  const onClose = async () => {
    //call the check-out on success function
    await onSuccess?.()
  }

  return (
    <React.Fragment>
      <div id="section-to-print" className="mb-2">
        <p>
          Bank transfers, also known as ACH payments, can take up to five business days. To pay via ACH, transfer funds
          using the following bank information.
        </p>
        <ul className="list-group">
          <li className="list-group-item d-flex justify-content-between">
            <div>Bank name</div>
            <div>{bankInfo?.bankName}</div>
          </li>
          <li className="list-group-item d-flex justify-content-between">
            <div>Routing number</div>
            <div>{bankInfo?.routingNumber}</div>
          </li>
          <li className="list-group-item d-flex justify-content-between">
            <div>Account number</div>
            <div>{bankInfo?.accountNumber}</div>
          </li>
          <li className="list-group-item d-flex justify-content-between">
            <div>SWIFT code</div>
            <div>{bankInfo?.swiftCode}</div>
          </li>
          <li className="list-group-item d-flex justify-content-between">
            <div>Amount to transfer</div>
            <div className="fw-bold"> {formatMoney(bankInfo?.amount)} </div>
          </li>
          <li className="list-group-item d-flex justify-content-between">
            <div>
              We sent this information to <strong className="text-primary">{bankInfo?.email}</strong>
            </div>
          </li>
        </ul>
      </div>

      <ButtonGroup>
        <BusyButton bsStyle="primary" text="Print" onClick={onPrint} />
        <BusyButton text="Close" className="btn-light" onClick={onClose} />
      </ButtonGroup>
    </React.Fragment>
  )
}
